import React from "react";
import { Link } from "react-router-dom";
import { Mail, MessageCircle, MapPin } from "lucide-react";
import { waLink } from "@/lib/constants";

export default function Contact() {
  return (
    <div data-testid="page-contact" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <header className="text-center mb-12">
        <p className="text-xs tracking-[0.3em] text-[#D4A63D] uppercase mb-4">Suntem aici</p>
        <h1 className="font-display text-4xl md:text-6xl text-[#F8F8F4]">Contact</h1>
        <p className="mt-4 text-[#A0AABF] text-lg">Cel mai rapid răspuns: pe WhatsApp.</p>
      </header>

      <div className="grid sm:grid-cols-2 gap-4 mb-10">
        <a href={waLink()} target="_blank" rel="noreferrer" className="cinematic-card rounded-lg p-6 group">
          <MessageCircle className="w-8 h-8 text-[#25D366] mb-3" />
          <div className="font-display text-xl text-[#F8F8F4] group-hover:text-[#D4A63D]">WhatsApp</div>
          <p className="text-sm text-[#A0AABF] mt-1">Răspuns în câteva ore</p>
        </a>
        <a href="mailto:contact@tatisisofia.ro" className="cinematic-card rounded-lg p-6 group">
          <Mail className="w-8 h-8 text-[#D4A63D] mb-3" />
          <div className="font-display text-xl text-[#F8F8F4] group-hover:text-[#D4A63D]">Email</div>
          <p className="text-sm text-[#A0AABF] mt-1">contact@tatisisofia.ro</p>
        </a>
      </div>

      <div className="cinematic-card rounded-lg p-8 text-center">
        <h3 className="font-display text-2xl text-[#F8F8F4]">Vrei o discuție personală?</h3>
        <p className="text-[#A0AABF] mt-2 mb-6">Programează o discuție 30/60 minute cu Gabriel.</p>
        <Link to="/programare" className="btn-gold rounded-sm px-6 py-3 inline-block text-sm uppercase tracking-widest">Programează acum</Link>
      </div>
    </div>
  );
}
